module.exports = __webpack_public_path__ + "static/the-girl-in-the-green-raincoat-7a4b949b1c3f54915d82b2d26fa9d3de.jpg";